module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-4-57543f806699fab02de96a18ed42626b.svg";